const rootArea = "/fields";

export const fieldGlob = (baseArea: string) => ({
	self: `${baseArea}${rootArea}`,
	byCode: (fieldCode: string) => ({ 					
		read: `${baseArea}${rootArea}/${fieldCode}/read`, 			
		edit: `${baseArea}${rootArea}/${fieldCode}/edit`
	})
});